import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { RegistrationData, UserClient } from 'api/clients/UserClient'

type Data = { user_registration_data: RegistrationData | null }

export const useRegistrationData = (options?: UseQueryOptions<Data>) => {
  return useQuery<Data>(
    'userRegistrationData',
    async () => {
      const res = await UserClient.getRegistrationData()

      if (res.type !== SUCCESS_RESPONSE_TYPE) throw new Error(res.data)

      return res.data
    },
    {
      refetchOnWindowFocus: false,
      staleTime: (options?.cacheTime || 0) * 0.5,
      ...options,
    },
  )
}
